import { createSelector, createStructuredSelector } from "reselect";
import { initialState, State as PlatformTransferState } from "./redux";

export const selectPlatformTransferDomain: (any) => PlatformTransferState = (
  state
) => state.platformTransfer || initialState;

export const selectPlatformTransfer = createSelector(
  selectPlatformTransferDomain,
  (substate) => substate
);

export const selectPlatform = createSelector(
  selectPlatformTransferDomain,
  (substate) => substate.platform
);

export const selectApplication = createSelector(
  selectPlatformTransferDomain,
  (substate) => substate.application
);

export const selectCidpId = createSelector(
  selectPlatformTransferDomain,
  (substate) => substate.cidpId
);

export const selectPartnerId = createSelector(
  selectPlatformTransferDomain,
  (substate) => substate.partnerId
);

export const makeSelectPlatformTransfer = () =>
  createSelector(selectPlatformTransferDomain, (substate) => substate);

export default createStructuredSelector({});
